import { img } from "./images";

export const products = [
  {
    id: "driving-shoes",
    name: "Driving Shoes",
    category: "Car Accessories",
    price: 49.99,
    oldPrice: 69.99,
    rating: 5,
    image: img("1542291026-7eec264c27ff", 600, 600),
    tag: "Sale",
    desc: "Premium leather and breathable fabric driving shoes designed for comfort during long shifts behind the wheel.",
    specs: [
      ["Material", "Premium Leather & Breathable Fabric"],
      ["Comfort", "Compact & Lightweight Design"],
      ["Fit", "True to size"],
    ],
    reviews: [
      { name: "James Parker", text: "Super comfortable for long driving shifts. Great quality leather!" },
    ],
  },
  {
    id: "bluetooth-headset",
    name: "Bluetooth Headset",
    category: "Car Accessories",
    price: 34.99,
    oldPrice: null,
    rating: 5,
    image: img("1505740420928-5e560c06d30e", 600, 600),
    tag: "New",
    desc: "Crystal-clear hands-free calling with deep bass and all-day battery life for drivers on the go.",
    specs: [
      ["Connectivity", "Bluetooth 5.0"],
      ["Battery Life", "Up to 12 Hours Playtime"],
      ["Sound Quality", "Crystal-Clear Audio with Deep Bass"],
      ["Design", "Compact & Lightweight Design"],
    ],
    reviews: [
      { name: "James Parker", text: "Great sound quality and long battery life! Perfect for my taxi rides." },
      { name: "Emma Wilson", text: "Compact and easy to use. Makes my rides more enjoyable!" },
    ],
  },
  {
    id: "gps-device",
    name: "GPS Navigation Device",
    category: "Car Electronics",
    price: 89.99,
    oldPrice: 109.99,
    rating: 5,
    image: img("1581092334651-ddf26d9a09d0", 600, 600),
    tag: "Sale",
    desc: "5-inch HD touchscreen GPS with real-time traffic updates and voice guidance for efficient routing.",
    specs: [
      ["Display", "5-inch HD Touchscreen"],
      ["Connectivity", "Wi-Fi & Bluetooth Enabled"],
      ["Features", "Real-time Traffic Updates, Voice Guidance"],
      ["Battery", "Rechargeable Lithium-ion, 6 Hours Backup"],
    ],
    reviews: [
      { name: "Mike Johnson", text: "Accurate and easy to use. Helps me find the best routes quickly!" },
      { name: "David Robinson", text: "Great GPS device for taxis! The real-time traffic updates are super helpful." },
    ],
  },
  {
    id: "phone-holder",
    name: "Car Phone Holder",
    category: "Car Accessories",
    price: 19.99,
    oldPrice: null,
    rating: 4,
    image: img("1601524909162-ae8725290836", 600, 600),
    tag: null,
    desc: "Sturdy, adjustable phone mount that keeps your navigation in clear view while you drive.",
    specs: [
      ["Material", "Heavy-Duty Rubber"],
      ["Compatibility", "Universal Fit"],
      ["Mount", "Air Vent & Dashboard"],
    ],
    reviews: [
      { name: "Mike Johnson", text: "Holds my phone securely even on bumpy roads. Highly recommend." },
    ],
  },
  {
    id: "emergency-kit",
    name: "Car Emergency Kit",
    category: "Vehicle Safety",
    price: 59.99,
    oldPrice: 79.99,
    rating: 5,
    image: img("1530124566582-a618bc2615dc", 600, 600),
    tag: "Sale",
    desc: "Be prepared for anything with a complete roadside emergency kit packed in a durable waterproof case.",
    specs: [
      ["Includes", "Bandages, Antiseptic Wipes, Gauze Pads, Scissors, Tape, Gloves, and More"],
      ["Case Material", "Durable Waterproof Plastic"],
      ["Portability", "Compact & Lightweight for Easy Storage"],
    ],
    reviews: [
      { name: "David Robinson", text: "Reliable and easy to use! Perfect for my garage and emergency situations." },
    ],
  },
  {
    id: "hydraulic-jack",
    name: "Hydraulic Car Jack",
    category: "Vehicle Maintenance",
    price: 119.99,
    oldPrice: null,
    rating: 5,
    image: img("1486262715619-67b85e0b08d3", 600, 600),
    tag: "New",
    desc: "Heavy-duty hydraulic jack with a reinforced steel frame for safe and effortless lifting.",
    specs: [
      ["Frame", "Reinforced Heavy-Duty Steel"],
      ["Load Capacity", "3 Tons"],
      ["Lifting Range", "5.5 to 20 inches"],
      ["System", "Hydraulic Lift System"],
    ],
    reviews: [
      { name: "Sophia Martinez", text: "Strong and stable. Lifted my SUV effortlessly!" },
    ],
  },
  {
    id: "microfiber-cloths",
    name: "Microfiber Cleaning Cloths",
    category: "Car Care",
    price: 14.99,
    oldPrice: 19.99,
    rating: 4,
    image: img("1607860108855-64acf2078ed9", 600, 600),
    tag: "Sale",
    desc: "Ultra-soft microfiber cloths that leave your vehicle spotless and streak-free.",
    specs: [
      ["Material", "High-Quality Cotton Blend"],
      ["Pack", "Set of 6"],
      ["Use", "Interior & Exterior"],
    ],
    reviews: [
      { name: "James Carter", text: "Leaves my taxi spotless. A clean, modern car makes a big difference." },
    ],
  },
  {
    id: "engine-oil",
    name: "Premium Engine Oil",
    category: "Vehicle Maintenance",
    price: 39.99,
    oldPrice: null,
    rating: 5,
    image: img("1635774855536-9728f2610245", 600, 600),
    tag: null,
    desc: "Fully synthetic engine oil for smoother performance, better fuel economy and engine protection.",
    specs: [
      ["Type", "Fully Synthetic"],
      ["Volume", "5 Litres"],
      ["Grade", "5W-30"],
    ],
    reviews: [
      { name: "Mike Johnson", text: "Keeps my engine running smoothly. Noticeable difference in performance." },
    ],
  },
];

export const productCategories = [
  "Car Accessories",
  "Car Electronics",
  "Vehicle Safety",
  "Vehicle Maintenance",
  "Car Care",
];
